module.exports = __webpack_public_path__ + "static/img/local.401fe1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/local.png
// module id = AAEp
// module chunks = 1